import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs, P } from "../../../AbstractElements";
import { OnScrollHideMenu, PageLayout, SampleCard, SampleCardText } from "../../../Constant";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import { MENU_ON_SCROLL } from "../../../Data/PageLayout";
import { useEffect } from "react";
import { setScrollMenu } from "../../../Redux-Toolkit/Reducers/LayoutSlice";
import { useLocation } from "react-router-dom";
import { useAppDispatch } from "../../../Redux-Toolkit/Hooks";

const HideNavScrollContainer = () => {
  const { pathname } = useLocation();
  const dispatch = useAppDispatch();
  const hideMenu = pathname === `${process.env.PUBLIC_URL}/page-layout/hide-nav-scroll`;

  useEffect(() => {
    const onScroll = () => {
      if (window.scrollY > 20 && hideMenu) dispatch(setScrollMenu(true));
      else dispatch(setScrollMenu(false));
    };
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, [dispatch, hideMenu]);

  return (
    <>
      <Breadcrumbs pageTitle={OnScrollHideMenu} parent={PageLayout} title={OnScrollHideMenu} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CommonCardHeader title={SampleCard} text={SampleCardText} />
              <CardBody>
                {MENU_ON_SCROLL.map((item, index) => (
                  <P key={index}>{item}</P>
                ))}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default HideNavScrollContainer;
